import { EventListeners, MinzeElement, Reactive } from "minze";

export interface ModalStatusEvent {
  status: "show" | "hide";
  modalId: string;
}

export interface TjModal {
  modalId: string;
  modalStatus: string;
  title: string;
  titleSize: string;
}

export class TjModal extends MinzeElement {
  attrs = ["modal-id", "title", "max-width", "title-size"];
  reactive: Reactive = [["modalStatus", "hide"]];

  toggleModal = (event: Event) => {
    const detail = (event as CustomEvent<ModalStatusEvent>).detail;
    if (this.modalId === detail.modalId) {
      if (detail.status === "show") {
        this.modalStatus = "show";
        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";
      } else {
        this.modalStatus = "hide";
        document.body.style.overflow = "auto";
        document.documentElement.style.overflow = "auto";
      }
    }

    this.rerender();
  };

  closeModal = () => {
    const mainModule = window.TJ_MAIN_MODULE;
    mainModule.hideModal(this.modalId);
  };

  html = () => `
    <div id="tj-modal-overlay" class="tj-modal-overlay ${this.modalStatus}">
    </div>
    <div id="tj-modal" class="tj-modal ${this.modalStatus}">
      <!-- Modal content -->
      <div class="tj-modal-content">
        <tj-box>
          <span class="tj-modal-close">&times;</span>
        </tj-box>
        <slot name="tj-modal-content"></slot>
      </div>
    </div>
  `;

  css = () => `
    ${
      this.modalStatus === "show"
        ? `
      :host {
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        z-index: 9999;
      }
    `
        : ""
    }
    
    slot[name="tj-modal-content"]::slotted(*) {
      padding-bottom: 2rem;
    }
    
    .tj-modal-overlay {
      position: fixed; /* Stay in place */
      z-index: 1; /* Sit on top */
      left: 0;
      top: 0;
      width: 100%; /* Full width */
      height: 100%; /* Full height */
      overflow: auto; /* Enable scroll if needed */
      opacity: 0.4;
      background: rgba(0,0,0,0.5);
    }

    .tj-modal-overlay.show {
      display: block
    }

    .tj-modal-overlay.hide {
      display: none
    }

    .tj-modal {
      height: fit-content;
      display: flex;
      z-index: 1401;
      max-width: 600px;
      margin: 0 auto;
      overflow: auto;
      background: #FFF;
      border-radius: 8px;
    }

    .tj-modal.show {
      display: block
    }

    .tj-modal.hide {
      display: none
    }

    .tj-modal-content {
      margin: auto;
      padding: 40px;
      width: 100%;
      position: relative;
      max-height: 90vh;
    }

    .tj-modal-close {
      color: #133762;
      font-size: 28px;
      font-weight: bold;
      position: absolute;
      top: 20px;
      right: 20px;
    }
    .tj-modal-close:hover,
    .tj-modal-close:focus {
      color: #aaaaaa;
      text-decoration: none;
      cursor: pointer;
    }

    .tj-modal-title {
      text-transform: uppercase;
    }

    @media only screen and (min-width: 300px) and (max-width: 620px){
      .tj-modal {
        width: 100%;
      }
    }

    @media only screen and (min-width: 621px) and (max-width: 960px){
      .tj-modal {
        width: 100%;
      }

      
      .tj-modal-content {
        border-radius:0px;
        max-width: 600px;
      }
    }

    @media only screen and (min-width: 960px) and (max-width: 1366px){
      .tj-modal {
        width: 100%;
      }

      .tj-modal-content {
        border-radius:0px;
        max-width: 600px;
      }
    }

    @media only screen and (min-width: 1366px) {
      .tj-modal {
        width: 100%;
      }

      .tj-modal-content {
        border-radius:0px;
        max-width: 600px;
      }
    }
    
    @media (max-width: 768px) {
      .tj-modal {
        height: 100vh;
        border-radius: 0;
      }
      .tj-modal-content {
        padding: 80px 20px;
      }
      .tj-modal-close {
        top: 40px;
      }
    }
  `;

  eventListeners: EventListeners = [
    [window, "tj:toggle-modal", this.toggleModal],
    [".tj-modal-close", "click", this.closeModal],
    [".tj-modal-overlay", "click", this.closeModal],
  ];
}
